import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { format } from 'date-fns';

/**
 * Returns a Set of mediator IDs that have at least one free availability
 * slot scheduled today or later. Used to render a "sans créneaux" badge
 * on mediators that are visible in search but cannot be booked right now.
 *
 * Note: we intentionally don't filter by mediator IDs here so that one
 * cached query covers every search component on the page.
 */
export const useMediatorsWithFutureSlots = () => {
  return useQuery({
    queryKey: ['mediatorsWithFutureSlots'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('availability_slots')
        .select('mediator_id')
        .eq('is_booked', false)
        .gte('date', format(new Date(), 'yyyy-MM-dd'));

      if (error) throw error;
      return new Set<string>((data ?? []).map(s => s.mediator_id));
    },
    staleTime: 60_000,
  });
};
